import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/CouponFill.tsx
const CouponFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 4a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1 1 1 0 0 1 0 2 1 1 0 0 0-1 1v3a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1 1 1 0 0 1 0-2 1 1 0 0 0 1-1V7a3 3 0 0 0-3-3H5Zm9 0v3a1 1 0 1 0 2 0V4h-2Zm2 16v-3a1 1 0 1 0-2 0v3h2Zm-1-10a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { CouponFillIcon };
